import { BackTestChartsWrapper } from 'components/common-form/sidePanel/backTest/BackTestChartsWrapper';
import type { ChartProps } from 'components/common-form/sidePanel/backTest/shared';
import { useBackTestOptions } from 'components/common-form/sidePanel/backTest/useBackTestOptions';
import type { Options, XAxisOptions, YAxisOptions } from 'highcharts';

export function PeriodSerie(props: ChartProps<string>) {
  const commonOptions = useBackTestOptions(props);
  const xAxisOptions = commonOptions.xAxis as XAxisOptions;
  const yAxisOptions = commonOptions.yAxis as YAxisOptions;

  const options: Options = {
    ...commonOptions,
    title: {
      text: '',
    },
    xAxis: {
      ...xAxisOptions,
      type: 'category',
      labels: {
        ...xAxisOptions?.labels,
        enabled: true,
        formatter() {
          return `${this.pos + 1}`;
        },
      },
    },
    yAxis: {
      ...yAxisOptions,
      title: {
        ...yAxisOptions?.title,
        text: '',
      },
    },
  };

  return <BackTestChartsWrapper highchartsOptions={options} />;
}
